import { useTranslation } from 'react-i18next';
import Breadcrumbs from '../../../../../common/widgets/Breadcrumbs';
import { resources } from '../../../resources/resources';
import applicationCrumbs from '../../ApplicationCrumbs';
import PlatformInformation from '../../Common/PlatformInformation';
import MyAccountMenu from '../Common/MyAccountMenu';
import { OrdersAndTransactions } from './Common/OrdersAndTransactions';

export const OrdersPage = () => {
  const { t: translate } = useTranslation();
  const crumbs = applicationCrumbs(translate);
  return (
    <>
      <Breadcrumbs
        entries={[crumbs.home, crumbs.accountDashboard, crumbs.orders]}
      />
      <section className="section-main section-actions my-account-page">
        <div className="container">
          <div className="area-actions">
            <MyAccountMenu />
          </div>
          <div className="area-content">
            <PlatformInformation />
            <div className="panel padding-xl">
              <div className="page-actions">
                <h1>{translate(resources.orders.title)}</h1>
              </div>
              <OrdersAndTransactions />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
